// import Vue from "vue"
// import router from "@/router"
import { make } from "vuex-pathify"
// import { Toast } from "buefy/dist/components/toast"
import ProductTypeProxy from "@/proxies/ProductTypeProxy"

const state = {
  productTypes: [],
  productType: {}
}

const mutations = make.mutations(state)

const actions = {
  async all({ commit }, params = {}) {
    let response = await new ProductTypeProxy(params).all()
    commit("SET_PRODUCT_TYPES", response)
  },

  async find({ commit }, id, params = {}) {
    let response = await new ProductTypeProxy(params).find(id)
    commit("SET_PRODUCT_TYPE", response)
  },

  async create(_, item) {
    return await new ProductTypeProxy().create(item)
  },

  async update({ dispatch }, { id, data, params = {} }) {
    let response = await new ProductTypeProxy(params).update(id, data)
    await dispatch("find", id)
    return response
  },

  async destroy(_, id, params = {}) {
    return await new ProductTypeProxy(params).destroy(id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
